// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ReviewInventoryIn {\n  height: 650px;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n}\n.ReviewInventoryIn .el-divider--horizontal {\n  margin: 8px 0;\n}", ""]);
// Exports
module.exports = exports;
